import gql from 'graphql-tag';

const CREATE_QUOTE = gql`
  mutation createQuote($createQuote: CreateQuoteInput!) {
    createQuote(input: $createQuote) {
      quoteId
      displayId
    }
  }
`;

const APPROVE_OR_REJECT_QUOTE = gql`
  mutation approveQuote($approveQuote: ApproveQuoteInput!) {
    approveQuote(input: $approveQuote)
  }
`;

const UPDATE_QUOTE = gql`
  mutation updateQuote(
    $updateQuote: UpdateQuoteInput!
    $isTaxSplitEnabled: Boolean!
  ) {
    updateQuote(input: $updateQuote) {
      quoteId
      displayId
      quoteDate
      expiryDate
      statusEnum
      customFields
      items {
        itemId
        itemOrder
        discountType
        discountAmount
        serviceItem {
          itemId
          name
          invoiceDescription
          quantityType
          roundUpValue
          unitPrice
          category {
            categoryId
            name
          }
          businessHoursUnitPrice
          afterHoursUnitPrice
          useAsWorklogItem
          quantity
        }
        serviceCatalogItem {
          itemId
          name
        }
        discountRate
        details
        quantity
        unitPrice
        amount
        taxable
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
      }
      client {
        accountId
        name
        logoFileName
      }
      site {
        id
        name
        line1
        line2
        line3
        countryCode
        stateCode
        city
        postalCode
      }
      senderAddress
      billingAddress
      discountAmount
      taxes {
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
        rate @include(if: $isTaxSplitEnabled) {
          rateId
          name
          rateValue
        }
        taxRate
        taxableAmount
        taxAmount
      }
      taxAmount
      totalAmount
      additionalDiscountType
      additionalDiscount
      additionalDiscountRate
      description
      title
      footer
      memo
      invoice {
        invoiceId
      }
      createdTime
    }
  }
`;

const DELETE_QUOTE = gql`
  mutation($input: [QuoteIdentifierInput!]!) {
    deleteQuotes(input: $input)
  }
`;

const CREATE_INVOICE_FROM_QUOTE = gql`
  mutation createInvoiceFromQuote(
    $createInvoiceFromQuoteInput: CreateInvoiceFromQuoteInput!
  ) {
    createInvoiceFromQuote(input: $createInvoiceFromQuoteInput) {
      invoiceId
      displayId
    }
  }
`;

export {
  CREATE_QUOTE,
  UPDATE_QUOTE,
  APPROVE_OR_REJECT_QUOTE,
  DELETE_QUOTE,
  CREATE_INVOICE_FROM_QUOTE
};
